import { useMemo } from 'react';
import { useSocialFeedSettings } from '../../utils';

export function useHeaderDisplayLogic() {
  const { headerElements = [] } = useSocialFeedSettings();

  return useMemo(
    () => ({
      shouldShowAvatar: headerElements.includes('authorPicture'),
      shouldShowUsername: headerElements.includes('username'),
      shouldShowName: headerElements.includes('authorName'),
      shouldShowBadge: headerElements.includes('verifiedBadge'),
      shouldShowFollowingCount: headerElements.includes('followingCount'),
      shouldShowFollowersCount: headerElements.includes('followersCount'),
      shouldShowLikesCount: headerElements.includes('likesCount'),
      shouldShowFollowButton: headerElements.includes('followButton'),
      hasAnyCounter:
        headerElements.includes('followingCount') ||
        headerElements.includes('followersCount') ||
        headerElements.includes('likesCount'),
      hasAnyName:
        headerElements.includes('username') ||
        headerElements.includes('authorName'),
      hasAnyVisibleElement:
        headerElements.filter(
          (headerElement) => headerElement !== 'verifiedBadge'
        ).length > 0
    }),
    [headerElements]
  );
}
